/**
 * First item of a `{ blk: [action] }` wrapper.
 * `wrapper.blk[0]` throws when `blk` is missing (FE-2485).
 */
export const getBlkAction = (wrapper: any) => wrapper?.blk?.[0];

/**
 * Inner payload of a delay-wrapped action (`{ wait, do: { blk: [action] } }`).
 * `do?.blk[0]` is unsafe: if `do` exists without `blk`, reading `[0]` throws (FE-2485).
 */
export const getDelayedSceneAction = (element: any) => getBlkAction(element?.do);

/**
 * Inner payload of an else-wrapped action (`{ else: { blk: [action] } }`).
 */
export const getElseSceneAction = (element: any) => getBlkAction(element?.else);

/**
 * GUI purpose from the outer action or its delay/else inner payload.
 */
export const getSceneActionPurpose = (element: any, inner?: any) =>
	element?._gui_type || element?._gui_purpose || inner?._gui_type || inner?._gui_purpose || undefined;
